// fr_pms_billing.ts
// Tłumaczenia dla PMS.Billing.tsx

export const frPmsBilling = {

  title:       "Facturation",
  description: "Folios des clients, facturation partagee, remboursements, ajustements, factures et conformite fiscale.",

  // ── Sekcje ───────────────────────────────────────────────────────────────
  sections: {
    folioWorkspace:      "Espace folio",
    folioActivity:       "Activite du folio",
    postCharges:         "Enregistrer des frais",
    refundsAdjustments:  "Remboursements et ajustements",
    invoicesFiscal:      "Factures et fiscalite",
    groupBillingSnapshot:"Apercu de la facturation de groupe",
  },

  // ── Opisy sekcji ─────────────────────────────────────────────────────────
  descriptions: {
    chargeWorkflow:  "Enregistrement des frais, reglement, facturation et processus d'ajustement.",
    currentItems:    "Elements actuels, paiements et remboursements pour le folio selectionne.",
    controlledReversal:"Processus controle d'annulation et d'ajustement.",
    partialPayments: "Paiements partiels et fractionnes avec plusieurs methodes.",
    generateInvoice: "Generer une facture et la transmettre via l'integration fiscale.",
    groupFolioSummary:"Le resume du folio de groupe reste disponible.",
  },

  // ── Metody płatności ──────────────────────────────────────────────────────
  paymentMethods: {
    card:      "Carte",
    cash:      "Especes",
    noPayment: "Aucun paiement",
    methodOne: "Methode de paiement 1",
    methodTwo: "Methode de paiement 2",
  },

  // ── Kategorie opłat ───────────────────────────────────────────────────────
  chargeCategories: {
    minibar:    "Minibar",
    lateCharge: "Frais de retard",
    other:      "Autres",
  },

  // ── Etykiety ──────────────────────────────────────────────────────────────
  labels: {
    folio:            "Folio",
    invoice:          "Facture",
    fiscalizedInvoice:"Facture fiscale",
    chargeCategory:   "Categorie de frais",
    balanceDue:       "Solde a payer",
    activeFolio:      "Folio actif",
    billingCompany:   "Societe de facturation",
    noFolioSelected:  "Aucun folio selectionne",
  },

  // ── Komunikaty ────────────────────────────────────────────────────────────
  messages: {
    adjustmentFailed: "Echec de l'ajustement.",
    chargeFailed:     "Echec de l'enregistrement des frais.",
    invoiceFailed:    "Echec de la generation de la facture.",
    refundFailed:     "Echec du remboursement.",
  },

} as const;

export default frPmsBilling;
